import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Subscription } from "rxjs";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../../shared/model/google-analytics-constants";
import { MapService } from "../../services/internal-services/map.service";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-zoom-manager",
  templateUrl: "./zoom.component.html",
  styleUrls: ["./zoom.component.scss"],
  standalone: false,
})
export class ZoomComponent implements AfterViewInit {
  viewerService = inject(VIEWER_SERVICE);

  constructor(
    protected googleAnalyticsService: GoogleAnalyticsService,
    private mapService: MapService,
  ) {}

  subscriptions: Subscription[] = [];

  lockZoomOut: boolean;

  lockZoomIn: boolean;

  ngAfterViewInit() {
    this.subscriptions.push(
      this.viewerService.image$.subscribe((event: any) => {
        if (event !== null) {
          const zoomInfo = this.mapService.getZoomInfo();
          this.lockZoomIn = zoomInfo.lockZoomIn;
          this.lockZoomOut = zoomInfo.lockZoomOut;
        }
      }),
    );

    this.subscriptions.push(
      this.viewerService.zoomEnd$.subscribe((event: any) => {
        if (event !== null) {
          this.lockZoomIn = event.lockZoomIn;
          this.lockZoomOut = event.lockZoomOut;
        }
      }),
    );
  }

  zoomIn(): void {
    this.mapService.getCoreMap().zoomIn();
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.ZOOM_IN,
      GoogleAnalyticsConstantsCategory.ZOOM_CONTROLLER,
      true,
    );
  }

  zoomOut(): void {
    this.mapService.getCoreMap().zoomOut();
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.ZOOM_OUT,
      GoogleAnalyticsConstantsCategory.ZOOM_CONTROLLER,
      true,
    );
  }
}
